import { useState } from "react";
import { toast } from "react-hot-toast";
import { forgotPassword } from "../../api";
import { Link, useNavigate } from "react-router-dom";

const ForgetPassword = () =>{
  const [enrollment,setEnrollment] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) =>{
    e.preventDefault();
    try{
      if(!enrollment){
        toast.error("Please fill all the fields");
        return;
      }
      await forgotPassword({email: `${enrollment}@darshan.ac.in`});
      navigate('/login');

      toast.success("📧 Password sent to your email!", {
        duration: 5000,
        style: {
          border: '1px solid #4caf50',
          padding: '16px',
          color: '#4caf50',
          fontWeight: 'bold',
          fontSize: '16px',
          borderRadius: '8px',
        },
      });
    }catch(err){
      toast.error("An error occured. Please try again later");
    }
  }
  return (
    <div className="min-h-[72vh] flex items-center justify-center p-4">
    <div className="w-full max-w-md">
      {/* Header */}
      <h1 className="text-center mb-8">
        <span className="text-4xl md:text-5xl font-bold bg-gradient-to-b from-[#190003] to-red-500 bg-clip-text text-transparent">
        Forgot Password
        </span>
      </h1>

      {/* Enrollment Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="bg-gradient-to-b from-[#190003] to-red-500 p-6 rounded-lg shadow-xl">
            <div className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-white text-sm font-medium mb-2">
                  Enrollment Number
                </label>
                <input
                      type="number"
                      id="email"
                      value={enrollment}
                      onChange={(e) => {
                        setEnrollment(e.target.value);
                      }}
                      className="w-full px-4 py-2 rounded-md bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-red-500"
                      placeholder="Enter your enrollment number"
                      required
                    />
              </div>
                <div className="text-left text-white">
                <p className='text-white cursor-pointer'><Link to="/Login">Login ?</Link></p>
              </div>
              <button
                type="submit"
                className="w-full bg-white text-red-500 py-2 px-4 rounded-md hover:bg-red-50 transition-colors duration-300 font-medium"
              >
                Submit
              </button>

                  <div className="text-center text-white">
                <p>Don't have an account? <Link to="/Register" className="text-white font-bold hover:underline">Register</Link></p>
              </div>
            </div>
          </div>
        </form>
    </div>
  </div>
  )
}

export default ForgetPassword;